import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import "../index.css";
import { GlobalContext } from "../context/GlobalContext";
import "../App.css";
import Cookies from "js-cookie";
import axios from "axios";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
function AddForm() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const {
    setFetchStatus,

    functions,
  } = useContext(GlobalContext);
  const {} = functions;

  const formik = useFormik({
    initialValues: {
      title: "",
      job_description: "",
      job_qualification: "",
      job_type: "",
      job_tenure: "",
      job_status: "",
      company_name: "",
      company_image_url: "",
      company_city: "",
      salary_min: "",
      salary_max: "",
    },
    validationSchema: Yup.object().shape({
      title: Yup.string()
        .required("title must be filled")
        .min(2, "Must be more than 2 characters"),

      job_description: Yup.string()
        .required("job_description must be filled")
        .min(10, "Must be more than 10 characters"),
      job_qualification: Yup.string()
        .required("job_qualification must be filled")
        .min(2, "Must be more than 2 characters"),
      job_type: Yup.string()
        .required("job_type must be filled")
        .min(2, "Must be more than 2 characters"),
      job_tenure: Yup.string()
        .required("job_tenure must be filled")
        .min(2, "Must be more than 2 characters"),
      company_name: Yup.string()
        .required("company_name must be filled")
        .min(2, "Must be more than 2 characters"),
      company_image_url: Yup.string()
        .required("company_image_url must be filled")
        .min(2, "Must be more than 2 characters"),
      company_city: Yup.string()
        .required("company_city must be filled")
        .min(2, "Must be more than 2 characters"),
      salary_min: Yup.number()
        .positive("Must be more than 0")
        .integer("Must be more than 0")
        .required("salary_min is required"),
      job_status: Yup.number().required(
        "Contoh value -> 0 dan 1. 0 untuk Ditutup, 1 untuk Dibuka"
      ),

      salary_max: Yup.number()
        .positive("Must be more than 0")
        .integer("Must be more than 0")
        .required("salary_max is required"),
    }),
    onSubmit: async () => {
      setIsLoading(true);
      let token = Cookies.get("token");
      try {
        await axios
          .post(
            "https://dev-example.sanbercloud.com/api/job-vacancy",
            formik.values,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then((res) => {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1000,
            });
          })
          .finally(() => {
            setTimeout(() => {
              setIsLoading(false);
              setFetchStatus(true);
              return navigate("/dashboard/list-job-vacancy");
            }, 1000);
          });
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: '<a href="">Why do I have this issue?</a>',
        });
      }
    },
  });

  return (
    <>
      <div class="container mx-auto  mb-10">
        <h1 class="text-xl font-bold ">Create Data</h1>
      </div>
      <div className="container mx-auto mt-10  mb-10">
        <small>Data Job</small>
        <hr className="mb-10" />
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Title
          </label>
          <input
            onChange={(e) => formik.setFieldValue("title", e.target.value)}
            name="title"
            type={"text"}
            placeholder="Contoh value -> FrontendDeveloper"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.title}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Job Description
          </label>
          <textarea
            onChange={(e) =>
              formik.setFieldValue("job_description", e.target.value)
            }
            name="job_description"
            type={"text"}
            placeholder="Contoh value -> Melakukan implementasi tampilan web dll"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.job_description}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Job Qualification
          </label>
          <textarea
            onChange={(e) =>
              formik.setFieldValue("job_qualification", e.target.value)
            }
            name="job_qualification"
            type={"text"}
            placeholder="Contoh value -> Harus bisa React dll"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.job_qualification}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Job Type
          </label>
          <input
            onChange={(e) => formik.setFieldValue("job_type", e.target.value)}
            name="job_type"
            type={"text"}
            placeholder="Contoh value -> onSite/work from home/hybir"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.job_type}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Job Tenure
          </label>
          <input
            onChange={(e) => formik.setFieldValue("job_tenure", e.target.value)}
            name="job_tenure"
            placeholder="Contoh value -> kontrak, magang dll"
            type={"text"}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.job_tenure}
          </div>
        </div>

        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Job Status (Contoh value : 0 dan 1. 0 untuk Ditutup, 1 untuk Dibuka)
          </label>
          <input
            onChange={(e) => formik.setFieldValue("job_status", e.target.value)}
            name="job_status"
            type={"number"}
            min={0}
            max={1}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.job_status}
          </div>
        </div>
        <small>Data Company</small>
        <hr className="mb-10" />
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Company Name
          </label>
          <input
            onChange={(e) =>
              formik.setFieldValue("company_name", e.target.value)
            }
            name="company_name"
            type={"text"}
            placeholder="Contoh value -> Google"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.company_name}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Company Image URL
          </label>
          <input
            onChange={(e) =>
              formik.setFieldValue("company_image_url", e.target.value)
            }
            name="company_image_url"
            type={"text"}
            placeholder="Contoh value ->  Bisa cari di google atau www.istockphoto.com dengan keyword company logo, klik kanan pada gambar lalu copy image address"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.company_image_url}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Company City
          </label>
          <input
            onChange={(e) =>
              formik.setFieldValue("company_city", e.target.value)
            }
            name="company_city"
            placeholder="Contoh value -> Jakarta"
            type={"text"}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.company_city}
          </div>
        </div>
        <small>Data Salary</small>
        <hr className="mb-10" />

        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Salary Min
          </label>
          <input
            onChange={(e) => formik.setFieldValue("salary_min", e.target.value)}
            name="salary_min"
            type={"number"}
            placeholder="Contoh value -> 9000000"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.salary_min}
          </div>
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            Salary Max
          </label>
          <input
            onChange={(e) => formik.setFieldValue("salary_max", e.target.value)}
            name="salary_max"
            type="number"
            placeholder="Contoh value -> 10000000"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="text-sm text-red-600 dark:text-red-500 font-bold">
            {formik.errors.salary_max}
          </div>
        </div>

        <button
          onClick={formik.handleSubmit}
          className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
        >
          Submit
        </button>
      </div>
    </>
  );
}
export default AddForm;
